export default __webpack_public_path__ + "static/media/Monger-HUD-Label.798c4b8c.jpg";